import { Link } from 'react-router-dom';
import images from "../assets/svg/not_found.svg";

const PageNotFound = () => {
    return (
        <div style={styles.container}>
            <div className='col-4'></div>
            <div className='col-4' style={styles.centerCol}>
                <div style={styles.textContainer}>
                    <h1 style={styles.heading}>404</h1>
                    <h2 style={styles.subheading}>Página no encontrada</h2>
                    <p style={styles.message}>Lo sentimos, la página que estás buscando no existe o ha sido movida.</p>
                    <Link to="/" style={styles.link}>Volver al inicio</Link>
                </div>
            </div>
            <div className='col-4'>
                <img src={images} alt="Not Found" style={styles.image} />
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh',
        backgroundColor: '#f4f4f4',
        padding: '0 2rem',
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    },
    centerCol: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    textContainer: {
        maxWidth: '500px',
        textAlign: 'center',
    },
    heading: {
        fontSize: '5rem',
        fontWeight: 'bold',
        color: '#72B500',
        marginBottom: '0.5rem',
    },
    subheading: {
        fontSize: '2rem',
        fontWeight: '600',
        color: '#333',
        marginBottom: '1rem',
    },
    message: {
        fontSize: '1.2rem',
        color: '#666',
        marginBottom: '2rem',
        lineHeight: '1.5',
    },
    link: {
        fontSize: '1rem',
        color: '#fff',
        textDecoration: 'none',
        border: 'none',
        padding: '0.75rem 1.5rem',
        borderRadius: '5px',
        backgroundColor: '#72B500',
        transition: 'background-color 0.3s ease',
    },
    image: {
        maxWidth: '400px',
        marginLeft: '2rem',
    },
};

export default PageNotFound;
